'use client';
import { useEffect } from 'react';
import { useRouter, useParams } from 'next/navigation';
import { Locales } from '@/types/i18n';

export default function Home() {
  const router = useRouter();
  const params = useParams();
  const locale = (params.locale as Locales) || 'en';

  useEffect(() => {
    // Redirect to merchants page immediately
    router.push(`/${locale}/merchants`);
  }, [locale, router]);

  // Return an empty div with a loading state to prevent flashing of not-found page
  return (
    <div style={{ display: 'none' }}>
      {/* Hidden loading state */}
    </div>
  );
}
